import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class LocalStorageService {
    private storage: Storage = window.localStorage;

    set(key: string, value: any): boolean {
        if (this.storage) {
            this.storage.setItem(key, JSON.stringify(value));
            return true;
        }
        return false;
    }

    get(key: string): string {
        if (this.storage) {
            const value = localStorage.getItem(key);

            try {
                return JSON.parse(value);
                //return JSON.stringify(parsedValue);
            } catch (error) {
                return value;
            }
        }
        return "";
    }

    remove(key: string): boolean {
        if (this.storage) {
            this.storage.removeItem(key);
            return true;
        }
        return false;
    }

    exist(key: string): boolean {
        if (this.storage) {
            if (this.storage.getItem(key) === null) {
                return false;
            }
            return true;
        }
        return false;
    }

    clear(): boolean {
        if (this.storage) {
            this.storage.clear();
            return true;
        }
        return false;
    }
}
